export default {
  goodGives(state) {
    return state.goodGives
  },
  goodGiveFilters(state) {
    return state.goodGiveFilters
  },
  goodGiveStatuses(state) {
    return state.goodGiveStatuses
  },
  goodGiveSearched(state) {
    return state.goodGiveSearched
  },
  goodGive(state) {
    return state.goodGive
  },
  goodGiveAvailable(state) {
    return state.goodGiveAvailable
  },
}
